module.exports = __webpack_public_path__ + "static/media/mobileSpashScreen.f8527163.png";